import { Box, Grid, Typography } from "@mui/material";
import { BrandsContext, TagLabel } from "contexts/Brands";
import { useContext } from "react";

import DiscoverChips from "./Chips";
import styles from "./styles";

interface Props {
  buttons?: JSX.Element;
  filtersList: JSX.Element;
  sortFilter?: JSX.Element;
  displayedSelectedTags: TagLabel[];
  newCampaignView?: boolean;
}

const DiscoverFilterDesktop = ({
  filtersList,
  sortFilter,
  buttons,
  displayedSelectedTags,
  newCampaignView,
}: Props) => {
  const { selectedMetadataTags } = useContext(BrandsContext);

  return (
    <Grid
      container
      sx={[
        styles.root,
        newCampaignView ? { backgroundColor: "transparent" } : {},
      ]}
    >
      <Grid container justifyContent="space-between" alignItems="center">
        {!newCampaignView && (
          <Grid item md={1.5}>
            <Typography sx={{ ml: 1 }} component="span">
              <strong>Categories</strong>
            </Typography>
          </Grid>
        )}

        <Grid
          container
          item
          xs
          alignItems="center"
          justifyContent={newCampaignView ? "flex-end" : "flex-start"}
          sx={{ gap: "6px" }}
        >
          {filtersList}
          {sortFilter && sortFilter}
        </Grid>
        {buttons && <Box sx={{ ml: 1 }}>{buttons}</Box>}
      </Grid>
      {(selectedMetadataTags.length > 0 ||
        displayedSelectedTags.length > 0) && (
        <Grid container>
          {!newCampaignView && <Grid item md={1} />}
          <DiscoverChips
            selectedMetadataTags={selectedMetadataTags}
            selectedTags={displayedSelectedTags}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default DiscoverFilterDesktop;
